import { sdk } from 'src/utilities/sdk';
import { CreateCorpResponse, CorpUIPayload, CorpPayload } from 'src/types/Corp';
import { decamelizeRequestBody } from 'src/utilities/http-data-casing';

export const getUpdateCorporateEndpoint = (corpId: string): string =>
  `/corps/${corpId}`;

export function updateCorporateDetails(
  corpId: string,
  corpData: CorpUIPayload
): Promise<CreateCorpResponse> {
  const decamelizedCorpData = decamelizeRequestBody(
    corpData
  ) as unknown as CorpPayload;
  return sdk.http.put(getUpdateCorporateEndpoint(corpId), decamelizedCorpData);
}
